import React, {useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import CardTable from "../../components/table/CardTable";
import columns from "./config/VerificationTableConfig";
import { useTranslation } from 'react-i18next';
import { hasAdmin } from '../../helpers/jwt';
import AdminVerificationTableConfig from './config/AdminVerificationTableConfig';

const MainPage = (props) => {

    const [loader, setLoader] = useState(false);
    const { t } = useTranslation();


    return (
      <>
        <Loader loader={loader} />
        <CustomContainer title={t('mainPage.verification')} className={'px-4'}>
          <CardTable
            tittle={t('mainPage.verificationList')}
            source={'verification'}
            columns={hasAdmin() ? AdminVerificationTableConfig(t) : columns(t)}
            width={12}
            setLoader={setLoader}
            striped={false}
            shadow={true}
            additionalFilter={(row) => !row.completed}
          />
        </CustomContainer>
      </>
    );
};

export default MainPage;
